/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import CloseAction from './CloseAction/index'
import DeleteAction from './DeleteAction/index'
import DeleteModal from './DeleteModal/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/App/Account/Content/Tasks/New/TaskOverlay/Content/Content/Header"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let taskBoardNameValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'board.name',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let taskStageNameValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'stage.name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let taskCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'task',
path: 'created_at',
format: fromFormat.timeAgoShort,
})
  return (<React.Fragment
>
<div
  data-testid="Header.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Header.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-Z2wmEtq': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 maxWidth={150}
 display="inline-block"
 overflowX="hidden"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 weight="medium"
 data="task.board.name"
 text={taskBoardNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral300}
 text="•"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="task.stage.name"
 text={taskStageNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral300}
 text="•"
/>
<div
  data-testid="Header.Horizontal:2"
  data-view-path={viewPath}
 style={{'--g-1-Z2wmEtq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Added"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 data="task.created_at"
 format="/Data/format.js timeAgoShort"
 text={taskCreatedAtValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral500}
 text="ago"
/>
</div>
</div>
<div
  data-testid="Header.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<DeleteAction
  viewPath={`${viewPath}/DeleteAction`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
</div>
<DeleteModal
  viewPath={`${viewPath}/DeleteModal`}
/>
{children}
</React.Fragment>)
}